import { LeagueRepository } from '../repositories';

export class RemoveLeagueParticipantUseCase {
  constructor(private leagueRepository: LeagueRepository) {}

  async execute(participantId: string, leagueId: string): Promise<void> {
    const league = await this.leagueRepository.getById(leagueId);
    if (!league) {
      throw new Error('League not found');
    }

    if (league.status !== 'setup') {
      throw new Error('Cannot remove participants after league has started');
    }

    await this.leagueRepository.removeParticipant(participantId);
  }
}
